import React from "react"

import { Loader2 } from "lucide-react"

const CellSpinner: React.FC = () => (
  <span className="flex justify-end">
    <Loader2 size={12} className="animate-spin text-palette-jungleGreen400" aria-label="Loading" />
  </span>
)

export default CellSpinner
